import { render, staticRenderFns } from "./EditControlDoctor.vue?vue&type=template&id=0df736b9&scoped=true"
import script from "./EditControlDoctor.vue?vue&type=script&lang=js"
export * from "./EditControlDoctor.vue?vue&type=script&lang=js"
import style0 from "./EditControlDoctor.vue?vue&type=style&index=0&id=0df736b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df736b9",
  null
  
)

export default component.exports